export const DEFAULT_THEME_NAME = 'default';
export { default as breakpoints } from './breakpoints';
export { default as colors } from './colors';
export { default as globalStyle } from './globalStyle';
export { default as typography } from './typography';
export { default as layouts, maxGridWidth, maxContainerWidth } from './layouts';
export { default as spacing } from './spacing';
//# sourceMappingURL=index.js.map